module.exports = __webpack_public_path__ + "img/placeholder.e641e18e.gif";